<template>
  <v-dialog :value="dialogProp.show" persistent max-width="500">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>
          {{ $t('Изменение даты оплаты договора') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-progress-linear v-if="isLoading" color="loader" indeterminate />
      <general-error v-if="!!generalError" />
      <v-card-text class="pt-2">
        <ValidationObserver ref="contractForm">
          <validatable-date-picker
              v-model="paymentDate"
              v-test="{ date: 'paymentDate' }"
              rules="required"
              :label="$t('Дата оплаты договора')" />
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'cancel' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="saveBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="send">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableDatePicker from '@/components/reused/ui/ValidatableDatePicker.vue'
  import { mapActions } from 'vuex'
  import { ORGANIZATION_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableDatePicker
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => ({
          show: false,
          date: null,
          organizationId: null,
          callback: () => {}
        })
      }
    },
    data () {
      return {
        isLoading: false,
        paymentDate: this.dialogProp.date
      }
    },
    created () {
      this.paymentDate = this.dialogProp.date
    },
    methods: {
      ...mapActions(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        updateContractPaymentDateAction: ORGANIZATION_MANAGEMENT.ACTIONS.UPDATE_CONTRACT_PAYMENT_DATE
      }),
      send: async function () {
        try {
          const result = await this.$refs.contractForm.validate()

          if (!result) {
            throw new Vue.errorsTypes.ValidationError()
          }
          this.isLoading = true
          await this.updateContractPaymentDateAction({
            organizationId: this.dialogProp.organizationId,
            paymentDate: this.paymentDate
          })
          this.isLoading = false
          if (this.dialogProp.callback) {
            this.dialogProp.callback()
          }
          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
